import { AbstractService } from '@uniqoders/sdk';
export default class UserService extends AbstractService {
    /**
     * Retrieves the logged user
     * @protected
     */
    retrieve() {
        return this.request('get', this.buildPath('/me'));
    }
    /**
     * Retrieves user stripe billing magic link
     * @protected
     */
    retrieveBilling() {
        return this.request('get', this.buildPath('/me/billing-portal'));
    }
    /**
     * Retrieves user subscription data
     * @protected
     */
    retrieveSubscription() {
        return this.request('get', this.buildPath('/me/subscription'));
    }
    /**
     * Updates User data
     * @param data
     * @protected
     */
    update(data) {
        return this.request('put', this.buildPath('/user/profile-information'), [], data);
    }
    /**
     * Updates User password
     * @param data
     * @protected
     */
    updatePassword(data) {
        return this.request('put', this.buildPath('/user/password'), [], data);
    }
}
